import * as St from './SelectedMaterialColor.styles';

import { ColorModel, MaterialModel } from '~/core/models';
import { imgUrl } from '~/core/utils';
import { vars } from '~/theme';
import SlabIcon, { slabIconVars } from '~atoms/SlabIcon';

interface SelectedMaterialColorProps {
  selectedMaterial: MaterialModel;
  selectedColor: ColorModel;
}

const SelectedMaterialColor = ({
  selectedColor,
  selectedMaterial,
}: SelectedMaterialColorProps): JSX.Element => (
  <St.Container>
    <St.TextArea>
      <SlabIcon
        style={vars({
          [slabIconVars.imgUrl]: `url("${imgUrl(
            selectedColor.swatchImageUrl
          )}")`,
        })}
      />
      <St.InformationContainer aria-label="Selected Material Information">
        <St.MaterialNameContainer>
          {selectedMaterial.description}
        </St.MaterialNameContainer>
        <span>{selectedColor.name}</span>
      </St.InformationContainer>
    </St.TextArea>
  </St.Container>
);

export default SelectedMaterialColor;
